import { saveStates, states } from '@/constants/lifecycle';
import { codeUrl } from '@/constants/urls';
import { findRequest } from '../../state/state';

export const newRequestWorkspace = ({ code }) => ({
  code,
  fields: {},
  isDirty: false,
  isNew: true,
  readErrors: [],
  readStatus: states.SUCCESS,
  ...saveStates,
  steps: {
    activeStepIndex: 0,
    results: [],
    sourceUrl: codeUrl('workspace/', code),
    isWorkspace: true,
  },
  workflows: [{ code: null }],
});

const findRequestWorkspaces = ({ requests }, { category, code }) => {
  const item = findRequest({ requests }, { category, code });
  return { item, workspaces: item?.steps.workspaces, locations: item?.steps.locations };
};

export const findWorkspaceRequest = (draft, { code }) => findRequest(draft, { code, category: 'workspaces' });

export default findRequestWorkspaces;
